import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../icons/CloseIcon';
import { CART_ERRORS } from '../../../actions/Cart';

class FreeModeError extends React.Component {
  constructor(props) {
    super(props);

    this.state = { showError: true };

    this.onCloseError = this.onCloseError.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps) {
    // When we go from no error to error, make the error visible
    if (this.props.code === null && nextProps.code !== null) {
      this.setState({ showError: true });
    }
  }

  onCloseError() {
    this.setState({ showError: false });
  }

  renderErrorMessage() {
    // Showing error for the room update mode
    if (this.props.source === 'occupancyUpdate') {
      return this.context.t('The occupancy of the room could not be updated');
    }

    // Showing error for the cart update mode
    switch (this.props.code) {
      case CART_ERRORS.MAX_ROOMS_REACHED:
        return this.context.t('No more than 5 rooms can be added to the basket');
      case CART_ERRORS.OTHER_REASON:
      default:
        return this.context.t('The room could not be added');
    }
  }

  render() {
    if (this.props.code === null || !this.state.showError) {
      return null;
    }
    return (
      <div className="FreeModeError">
        <CloseIcon onClick={this.onCloseError} />
        {this.props.children}
        <p>
          {this.renderErrorMessage()}
        </p>
      </div>
    );
  }
}

FreeModeError.propTypes = {
  children: PropTypes.node, // The title that will be displayed in the message
  source: PropTypes.string,
  code: PropTypes.string,
};

FreeModeError.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default FreeModeError;
